module.exports = __webpack_public_path__ + "img/gi.fb52d8c2.svg";